// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { useNavigate } from 'react-router-dom';
// import { Base_Url } from '../config';
// import { FaEdit, FaEye } from "react-icons/fa";
// import { useSelector } from 'react-redux';

// const RouteCreationForm = () => {
//     const navigate = useNavigate();

//     // State for form fields - Added isroutesisused
//     const [formData, setFormData] = useState({
//         routes: '',
//         iscard: false,
//         cardsinfo: '',
//         ispage: false,
//         pageinfo: '',
//         isroutesisused: false  
//     });

//     const statecsc = useSelector((state) => state.statecsc)

//     // console.log(statecsc,"app js userstate")

//     // State for existing routes and dropdown
//     const [existingRoutes, setExistingRoutes] = useState([]);
//     const [searchTerm, setSearchTerm] = useState('');

//     // State for error and success handling
//     const [error, setError] = useState('');
//     const [success, setSuccess] = useState('');
//     const [loading, setLoading] = useState(false);
//     const [allCardsPageTitle, setAllCardsPageTitle] = useState([])
//     const [allPages, setAllPages] = useState([])
//     // Fetch existing routes on component mount
//     useEffect(() => {
//         const fetchRoutes = async () => {
//             try {
//                 const response = await axios.get(`${Base_Url}/createroutes`);
//                 setExistingRoutes(Array.isArray(response.data) ? response.data : []);
//             } catch (err) {
//                 console.error('Failed to fetch routes', err);
//                 setExistingRoutes([]);
//             }
//         };
//         fetchRoutes();
//     }, []);

//     // Handle input changes - Updated to handle new field
//     const handleChange = (e) => {
//         const { name, value, type, checked } = e.target;

//         if (type === 'checkbox') {
//             if (name === 'iscard' && checked) {
//                 setFormData(prev => ({
//                     ...prev,
//                     iscard: true,
//                     ispage: false
//                 }));
//             } else if (name === 'ispage' && checked) {
//                 setFormData(prev => ({
//                     ...prev,
//                     ispage: true,
//                     iscard: false
//                 }));
//             } else {
//                 setFormData(prev => ({
//                     ...prev,
//                     [name]: checked
//                 }));
//             }
//         } else if (name === 'routes') {
//             setFormData(prev => ({ ...prev, routes: value }));
//             setSearchTerm(value);
//         } else {
//             setFormData(prev => ({
//                 ...prev,
//                 [name]: value
//             }));
//         }
//     };

//     // Handle form submission - Updated to include isroutesisused
//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         setError('');
//         setSuccess('');

//         if (!validateForm()) return;

//         // Always set isroutesisused to false when creating a new route
//         const payload = {
//             ...formData,
//             isroutesisused: false,
//             cardsinfo: formData.cardsinfo ? JSON.parse(formData.cardsinfo) : null,
//             pageinfo: formData.pageinfo ? JSON.parse(formData.pageinfo) : null
//         };

//         setLoading(true);

//         try {
//             const response = await axios.post(`${Base_Url}/createroutes`, payload);

//             setExistingRoutes(prev => [...prev, response.data]);

//             setSuccess('Route created successfully!');

//             // Reset form, including new field
//             setFormData({
//                 routes: '',
//                 iscard: false,
//                 cardsinfo: '',
//                 ispage: false,
//                 pageinfo: '',
//                 isroutesisused: false
//             });
//         } catch (err) {
//             setError(err.response?.data?.error || 'Failed to create route');
//         } finally {
//             setLoading(false);
//         }
//     };

//     // Validation remains the same
//     const validateForm = () => {
//         const routesArray = Array.isArray(existingRoutes) ? existingRoutes : [];
//         const routeExists = routesArray.some(
//             route => route && route.routes &&
//                 route.routes.toLowerCase() === formData.routes.trim().toLowerCase()
//         );

//         if (routeExists) {
//             setError('Route already exists');
//             return false;
//         }

//         if (!formData.routes.trim()) {
//             setError('Routes is required');
//             return false;
//         }

//         if (!formData.iscard && !formData.ispage) {
//             setError('Please select either Card or Page');
//             return false;
//         }

//         return true;
//     };


//     useEffect(() => {
//         const fetchCardsPageTitle = async () => {
//             try {
//                 const response = await axios.get(`${Base_Url}/card-descriptions`);
//                 setAllCardsPageTitle(Array.isArray(response.data) ? response.data : []);
//             } catch (err) {
//                 console.error('Failed to fetch routes', err);
//                 setAllCardsPageTitle([]);
//             }
//         };
//         fetchCardsPageTitle();
//     }, []);
//     useEffect(() => {
//         const fetchAllPages = async () => {
//             try {
//                 const response = await axios.get(`${Base_Url}/pages`);
//                 setAllPages(Array.isArray(response.data) ? response.data : []);
//             } catch (err) {
//                 console.error('Failed to fetch routes', err);
//                 setAllPages([]);
//             }
//         };
//         fetchAllPages();
//     }, []);


//     // console.log(allCardsPageTitle)
//     // console.log(allPages,"pages data")

//     // Handle route deletion
//     const handleDeleteRoute = async (routeId) => {
//         const isConfirmed = window.confirm("Are you sure you want to delete this route?");
        
//         if (!isConfirmed) {
//             return;
//         }
    
//         try {
//             await axios.delete(`${Base_Url}/createroutes/${routeId}`);
//             setExistingRoutes(prev => prev.filter(route => route.id !== routeId));
//             setSuccess('Route deleted successfully!');
//         } catch (err) {
//             setError(err.response?.data?.error || 'Failed to delete route');
//         }
//     };
    

//     // Navigate to Add Card/Page routes
//     const navigateToAddRoute = (route) => {
//         // Only navigate if route is not already used
//         if (!route.isroutesisused) {
//             if (route.iscard) {
//                 navigate(`/add-card/${route.id}`);
//             } else if (route.ispage) {
//                 navigate(`/add-page/${route.id}`);
//             }
//         }
//     };
//     const navigateToAddCardtitle = (route) => {
//         // Only navigate if route is not already used
//         if (!route.isroutesisused) {
//             if (route.iscard) {
//                 navigate(`/add-cardtitle/${route.id}`);
//             } else if (route.ispage) {
//                 navigate(`/add-cardtitle/${route.id}`);
//             }
//         }
//     };
//     const navigateToEditCardtitle = (route) => {
//         console.log(route)
//         // Only navigate if route is not already used
//         if (!route.isroutesisused) {
//             if (route.iscard) {
//                 navigate(`/edit-cardtitle/${route.id}`);
//             } else if (route.ispage) {
//                 navigate(`/edit-cardtitle/${route.id}`);
//             }
//         }
//     };
//     const navigateToRoute = (route) => {
//         // Only navigate if route is not already used
   
//                 navigate(`/${route}`);

//     };

//     return (
//         <div className="container mt-5">
//             <div className="row">
//                 <div className="col-md-6">
//                     <div className="card shadow mb-4">
//                         <div className="card-header bg-danger text-white">
//                             <h3 className="mb-0 text-white">Create New Route</h3>
//                         </div>
//                         <div className="card-body">
//                             {error && (
//                                 <div className="alert alert-danger" role="alert">
//                                     {error}
//                                 </div>
//                             )}
//                             {success && (
//                                 <div className="alert alert-success" role="alert">
//                                     {success}
//                                 </div>
//                             )}
//                             <form onSubmit={handleSubmit}>
//                                 <div className="mb-3">
//                                     <label htmlFor="routes" className="form-label">
//                                         Routes <span className="text-danger">*</span>
//                                     </label>
//                                     <input
//                                         type="text"
//                                         className="form-control"
//                                         id="routes"
//                                         name="routes"
//                                         value={formData.routes}
//                                         onChange={handleChange}
//                                         placeholder="Enter route"
//                                         required
//                                     />
//                                 </div>

//                                 <div className="row mb-3">
//                                     <div className="col-md-6">
//                                         <div className="form-check">
//                                             <input
//                                                 type="checkbox"
//                                                 className="form-check-input"
//                                                 id="iscard"
//                                                 name="iscard"
//                                                 checked={formData.iscard}
//                                                 onChange={handleChange}
//                                             />
//                                             <label className="form-check-label" htmlFor="iscard">
//                                                 Is Card
//                                             </label>
//                                         </div>
//                                     </div>
//                                     <div className="col-md-6">
//                                         <div className="form-check">
//                                             <input
//                                                 type="checkbox"
//                                                 className="form-check-input"
//                                                 id="ispage"
//                                                 name="ispage"
//                                                 checked={formData.ispage}
//                                                 onChange={handleChange}
//                                             />
//                                             <label className="form-check-label" htmlFor="ispage">
//                                                 Is Page
//                                             </label>
//                                         </div>
//                                     </div>
//                                 </div>

//                                 <div className="d-grid">
//                                     <button
//                                         type="submit"
//                                         className="btn btn-primary text-white bg-danger btn-outline-danger"
//                                         disabled={loading}
//                                     >
//                                         {loading ? 'Creating...' : 'Create Route'}
//                                     </button>
//                                 </div>
//                             </form>
//                         </div>
//                     </div>
//                 </div>

//                 <div className="col-md-6">
//                     <div className="card shadow">
//                         <div className="card-header bg-primary text-white">
//                             <h4 className="mb-0">Existing Routes</h4>
//                         </div>
//                         <div className="card-body p-0">
//                             <table className="table table-striped mb-0">
//                                 <thead>
//                                     <tr>
//                                         <th>Route</th>
//                                         <th>Type</th>
//                                         <th className='text-center'>Actions</th>
//                                     </tr>
//                                 </thead>
//                                 <tbody>
//                                     {
//                                         existingRoutes.map((route) => {

//                                             // console.log(route)
//                                             // console.log(allCardsPageTitle.some(item => item.route_id == route.id))

//                                             let whichpagehasdata = allPages.some(item => item.route_id == route.id)
//                                             return (
//                                                 <>
//                                                     <tr key={route.id}>
//                                                         <td className='text-lowercase'>{route.routes} 
//                                                             {
//                                                                 statecsc.userState == 0 ?   <FaEdit color='blue' onClick={()=>navigate(`/edit-routes/${route.id}`)}/> : ""
//                                                             }
                                                          

//                                                             </td>
//                                                         <td>
//                                                             {route.iscard ? 'Card' : route.ispage ? 'Page' : 'N/A'}
//                                                         </td>
//                                                         <td>
//                                                             <div className="d-flex justify-content-lg-evenly">
//                                                                 {
//                                                                      route.ispage ?   <button
//                                                                      className="btn btn-sm btn-info"
//                                                                      disabled={route.isroutesisused}
//                                                                      onClick={() => navigateToRoute(route.routes)}
//                                                                  >
//                                                                     {route.isroutesisused && whichpagehasdata ? 'Used' : route.isroutesisused != true && whichpagehasdata ? "Edit" : "Add" }
//                                                                  </button> :  <button
//                                                                     className="btn btn-sm btn-info me-1"
//                                                                     onClick={() => navigateToAddRoute(route)}
//                                                                     disabled={route.isroutesisused}
//                                                                 >
//                                                                     {route.isroutesisused ? 'Used' : 'Add'}
//                                                                 </button>
//                                                                 }
                                                               


//                                                                 {route.iscard && allCardsPageTitle.some(item => item.route_id === route.id) ? (

//                                                                     <button
//                                                                         className="btn btn-sm btn-warning me-1"
//                                                                         onClick={() => navigateToEditCardtitle(route)}
//                                                                     >
//                                                                         Edit Card Title
//                                                                     </button>
//                                                                 ) : route.ispage ? (
//                                                                     <button
//                                                                         disabled
//                                                                         className="btn btn-sm btn-warning me-1"
//                                                                     >
//                                                                         N/A
//                                                                     </button>
//                                                                 ) : (
//                                                                     <button
//                                                                         className="btn btn-sm btn-warning me-1"
//                                                                         onClick={() => navigateToAddCardtitle(route)}
//                                                                     >
//                                                                         Add Card Title
//                                                                     </button>
//                                                                 )}

//                                                                 <button
//                                                                     className="btn btn-sm btn-primary"
//                                                                     onClick={() => navigateToRoute(route.routes)}
//                                                                 >
//                                                                     <FaEye />
//                                                                 </button>
//                                                                 <button
//                                                                     className="btn btn-sm btn-danger"
//                                                                     onClick={() => handleDeleteRoute(route.id)}
//                                                                 >
//                                                                     Delete
//                                                                 </button>
//                                                             </div>
//                                                         </td>
//                                                     </tr>
//                                                 </>
//                                             )
//                                         })
//                                     }

//                                 </tbody>
//                             </table>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default RouteCreationForm;


import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Base_Url } from '../config';
import { FaEdit, FaEye } from "react-icons/fa";
import { useSelector } from 'react-redux';

const RouteCreationForm = () => {
    const navigate = useNavigate();

    // State for form fields - Added isroutesisused
    const [formData, setFormData] = useState({
        routes: '',
        iscard: false,
        cardsinfo: '',
        ispage: false,
        pageinfo: '',
        isroutesisused: false  
    });

    const statecsc = useSelector((state) => state.statecsc)

    // State for existing routes and dropdown
    const [existingRoutes, setExistingRoutes] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');

    // State for error and success handling
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [loading, setLoading] = useState(false);
    const [allCardsPageTitle, setAllCardsPageTitle] = useState([])
    const [allPages, setAllPages] = useState([])
    
    // Fetch existing routes on component mount
    useEffect(() => {
        const fetchRoutes = async () => {
            try {
                const response = await axios.get(`${Base_Url}/createroutes`);
                setExistingRoutes(Array.isArray(response.data) ? response.data : []);
            } catch (err) {
                console.error('Failed to fetch routes', err);
                setExistingRoutes([]);
            }
        };
        fetchRoutes();
    }, []);

    // Handle input changes - Updated to handle new field
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        if (type === 'checkbox') {
            if (name === 'iscard' && checked) {
                setFormData(prev => ({
                    ...prev,
                    iscard: true,
                    ispage: false
                }));
            } else if (name === 'ispage' && checked) {
                setFormData(prev => ({
                    ...prev,
                    ispage: true,
                    iscard: false
                }));
            } else {
                setFormData(prev => ({
                    ...prev,
                    [name]: checked
                }));
            }
        } else if (name === 'routes') {
            setFormData(prev => ({ ...prev, routes: value }));
            setSearchTerm(value);
        } else {
            setFormData(prev => ({
                ...prev,
                [name]: value
            }));
        }
    };

    // Handle form submission - Updated to include isroutesisused
    const handleSubmit = async (e) => {
        e.preventDefault();

        setError('');
        setSuccess('');

        if (!validateForm()) return;

        // Always set isroutesisused to false when creating a new route
        const payload = {
            ...formData,
            isroutesisused: false,
            cardsinfo: formData.cardsinfo ? JSON.parse(formData.cardsinfo) : null,
            pageinfo: formData.pageinfo ? JSON.parse(formData.pageinfo) : null
        };

        setLoading(true);

        try {
            const response = await axios.post(`${Base_Url}/createroutes`, payload);

            setExistingRoutes(prev => [...prev, response.data]);

            setSuccess('Route created successfully!');

            // Reset form, including new field
            setFormData({
                routes: '',
                iscard: false,
                cardsinfo: '',
                ispage: false,
                pageinfo: '',
                isroutesisused: false
            });
        } catch (err) {
            setError(err.response?.data?.error || 'Failed to create route');
        } finally {
            setLoading(false);
        }
    };

    // Validation remains the same
    const validateForm = () => {
        const routesArray = Array.isArray(existingRoutes) ? existingRoutes : [];
        const routeExists = routesArray.some(
            route => route && route.routes &&
                route.routes.toLowerCase() === formData.routes.trim().toLowerCase()
        );

        if (routeExists) {
            setError('Route already exists');
            return false;
        }

        if (!formData.routes.trim()) {
            setError('Routes is required');
            return false;
        }

        if (!formData.iscard && !formData.ispage) {
            setError('Please select either Card or Page');
            return false;
        }

        return true;
    };


    useEffect(() => {
        const fetchCardsPageTitle = async () => {
            try {
                const response = await axios.get(`${Base_Url}/card-descriptions`);
                setAllCardsPageTitle(Array.isArray(response.data) ? response.data : []);
            } catch (err) {
                console.error('Failed to fetch routes', err);
                setAllCardsPageTitle([]);
            }
        };
        fetchCardsPageTitle();
    }, []);
    
    useEffect(() => {
        const fetchAllPages = async () => {
            try {
                const response = await axios.get(`${Base_Url}/pages`);
                setAllPages(Array.isArray(response.data) ? response.data : []);
            } catch (err) {
                console.error('Failed to fetch routes', err);
                setAllPages([]);
            }
        };
        fetchAllPages();
    }, []);

    // Handle route deletion
    const handleDeleteRoute = async (routeId) => {
        const isConfirmed = window.confirm("Are you sure you want to delete this route?");
        
        if (!isConfirmed) {
            return;
        }
    
        try {
            await axios.delete(`${Base_Url}/createroutes/${routeId}`);
            setExistingRoutes(prev => prev.filter(route => route.id !== routeId));
            setSuccess('Route deleted successfully!');
        } catch (err) {
            setError(err.response?.data?.error || 'Failed to delete route');
        }
    };
    
    // Navigate to Add Card/Page routes
    const navigateToAddRoute = (route) => {
        // Only navigate if route is not already used
        if (!route.isroutesisused) {
            if (route.iscard) {
                navigate(`/add-card/${route.id}`);
            } else if (route.ispage) {
                navigate(`/add-page/${route.id}`);
            }
        }
    };
    
    // Navigate to Edit Page route
    const navigateToEditPage = (routeId) => {
        navigate(`/edit-page/${routeId}`);
    };
    
    const navigateToAddCardtitle = (route) => {
        // Only navigate if route is not already used
        if (!route.isroutesisused) {
            navigate(`/add-cardtitle/${route.id}`);
        }
    };
    
    const navigateToEditCardtitle = (route) => {
        // Only navigate if route is not already used
        if (!route.isroutesisused) {
            navigate(`/edit-cardtitle/${route.id}`);
        }
    };
    
    const navigateToRoute = (routePath) => {
        // Ensure the route path starts with a slash
        const formattedRoute = routePath.startsWith('/') ? routePath : `/${routePath}`;
        
        // Navigate to the route
        navigate(formattedRoute);
    };

    return (
        <div className="container mt-5">
            <div className="row">
                <div className="col-md-6">
                    <div className="card shadow mb-4">
                        <div className="card-header bg-danger text-white">
                            <h3 className="mb-0 text-white">Create New Route</h3>
                        </div>
                        <div className="card-body">
                            {error && (
                                <div className="alert alert-danger" role="alert">
                                    {error}
                                </div>
                            )}
                            {success && (
                                <div className="alert alert-success" role="alert">
                                    {success}
                                </div>
                            )}
                            <form onSubmit={handleSubmit}>
                                <div className="mb-3">
                                    <label htmlFor="routes" className="form-label">
                                        Routes <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="routes"
                                        name="routes"
                                        value={formData.routes}
                                        onChange={handleChange}
                                        placeholder="Enter route"
                                        required
                                    />
                                </div>

                                <div className="row mb-3">
                                    <div className="col-md-6">
                                        <div className="form-check">
                                            <input
                                                type="checkbox"
                                                className="form-check-input"
                                                id="iscard"
                                                name="iscard"
                                                checked={formData.iscard}
                                                onChange={handleChange}
                                            />
                                            <label className="form-check-label" htmlFor="iscard">
                                                Is Card
                                            </label>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-check">
                                            <input
                                                type="checkbox"
                                                className="form-check-input"
                                                id="ispage"
                                                name="ispage"
                                                checked={formData.ispage}
                                                onChange={handleChange}
                                            />
                                            <label className="form-check-label" htmlFor="ispage">
                                                Is Page
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div className="d-grid">
                                    <button
                                        type="submit"
                                        className="btn btn-primary text-white bg-danger btn-outline-danger"
                                        disabled={loading}
                                    >
                                        {loading ? 'Creating...' : 'Create Route'}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                <div className="col-md-6">
                    <div className="card shadow">
                        <div className="card-header bg-primary text-white">
                            <h4 className="mb-0">Existing Routes</h4>
                        </div>
                        <div className="card-body p-0">
                            <table className="table table-striped mb-0">
                                <thead>
                                    <tr>
                                        <th>Route</th>
                                        <th>Type</th>
                                        <th className='text-center'>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {existingRoutes.map((route) => {
                                        const hasCardTitle = allCardsPageTitle.some(item => item.route_id === route.id);
                                        const hasPageData = allPages.some(item => item.route_id === route.id);
                                        
                                        return (
                                            <tr key={route.id}>
                                                <td className='text-lowercase'>
                                                    {route.routes} 
                                                    {statecsc.userState === 0 && 
                                                        <FaEdit 
                                                            color='blue' 
                                                            onClick={() => navigate(`/edit-routes/${route.id}`)}
                                                            style={{cursor: 'pointer', marginLeft: '10px'}}
                                                        />
                                                    }
                                                </td>
                                                <td>
                                                    {route.iscard ? 'Card' : route.ispage ? 'Page' : 'N/A'}
                                                </td>
                                                <td>
                                                    <div className="d-flex justify-content-lg-evenly">
                                                        {route.ispage ? (
                                                            <button
                                                                className="btn btn-sm btn-info me-1"
                                                                onClick={() => hasPageData ? navigateToEditPage(route.id) : navigateToAddRoute(route)}
                                                                disabled={route.isroutesisused}
                                                            >
                                                                {hasPageData ? 'Edit Page' : 'Add Page'}
                                                            </button>
                                                        ) : (
                                                            <button
                                                                className="btn btn-sm btn-info me-1"
                                                                onClick={() => navigateToAddRoute(route)}
                                                                disabled={route.isroutesisused}
                                                            >
                                                                {route.isroutesisused ? 'Used' : 'Add Card'}
                                                            </button>
                                                        )}

                                                        {route.iscard ? (
                                                            hasCardTitle ? (
                                                                <button
                                                                    className="btn btn-sm btn-warning me-1"
                                                                    onClick={() => navigateToEditCardtitle(route)}
                                                                >
                                                                    Edit Card Title
                                                                </button>
                                                            ) : (
                                                                <button
                                                                    className="btn btn-sm btn-warning me-1"
                                                                    onClick={() => navigateToAddCardtitle(route)}
                                                                >
                                                                    Add Card Title
                                                                </button>
                                                            )
                                                        ) : (
                                                            <button
                                                                disabled
                                                                className="btn btn-sm btn-warning me-1"
                                                            >
                                                                N/A
                                                            </button>
                                                        )}

                                                        <button
                                                            className="btn btn-sm btn-primary me-1"
                                                            onClick={() => navigateToRoute(route.routes)}
                                                        >
                                                            <FaEye />
                                                        </button>
                                                        
                                                        <button
                                                            className="btn btn-sm btn-danger"
                                                            onClick={() => handleDeleteRoute(route.id)}
                                                        >
                                                            Delete
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RouteCreationForm;